import React from 'react';
import { LocalServicePage } from '../../components/LocalServicePage';

export const LocksmithDagenham = () => {
  return (
    <LocalServicePage
      areaName="Dagenham"
      areaType="City"
      slug="locksmith-dagenham"
      heroTitle="Door, Window & Lock Repairs in Dagenham"
      heroSubtitle="Royal Security provides specialist repairs for doors, windows, and locks across Dagenham. We serve homeowners, landlords, and letting agents with honest diagnosis and quality workmanship."
      introContent={
        <>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Dagenham has one of the UK's most distinctive housing legacies—the Becontree estate alone contains over 25,000 homes. We've worked extensively across Dagenham, from the original estate properties to the newer developments around the town centre and Beam Park, understanding the specific issues that affect doors and windows here.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our approach suits Dagenham well: practical, no-nonsense repairs that fix the problem without unnecessary expense. Many properties here have had their windows and doors replaced over the years, and those installations are now reaching ages where mechanisms wear and components need attention. We restore them to reliable operation.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            We work with private homeowners, landlords with rental properties in the area, and letting agents managing portfolios. Whatever your situation, you'll get the same honest advice and quality service.
          </p>
        </>
      }
      servicesEmphasis={[
        {
          title: "uPVC Door & Window Repairs",
          description: "uPVC is the predominant material across Dagenham's housing stock. We repair all aspects—locks, handles, hinges, mechanisms, and seals. If your uPVC door or window isn't working properly, we'll diagnose and fix the problem."
        },
        {
          title: "Multipoint Lock Services",
          description: "The multipoint locks on modern doors can develop faults—gearbox failure, worn hooks, damaged keeps, or misaligned components. We identify exactly what's wrong and repair or replace the necessary parts."
        },
        {
          title: "Door Realignment & Adjustment",
          description: "Doors that drag, stick, or won't close properly often just need expert adjustment. We realign doors, adjust hinges, and set up locks to operate smoothly—usually far more effective than the 'new door' quote you might get elsewhere."
        },
        {
          title: "Tilt & Turn Window Repairs",
          description: "Tilt and turn windows are common in flats and newer houses across Dagenham. When mechanisms fail or windows get stuck, we repair the specific hardware at fault."
        },
        {
          title: "Double Glazing Repairs",
          description: "Misted units, cracked glass, and failed seals don't always mean new windows. We replace sealed units within your existing frames, offering options to upgrade glass performance if desired."
        },
        {
          title: "Landlord & Rental Property Services",
          description: "Dagenham has a significant rental sector. We provide prompt, reliable services for landlords and agents—repairs between tenancies, emergency response, and ongoing maintenance agreements."
        }
      ]}
      localContextTitle="Keeping Older uPVC Doors & Windows Working in Dagenham"
      localContext={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Repair before replace:</strong> Older uPVC doors and windows can still have sound frames with worn moving parts. Where inspection confirms that, replacing a gearbox, hinges or handles can restore smooth, secure operation without replacing the door.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            <strong>Matching older parts:</strong> Some older locking mechanisms are no longer made. We measure the backset, centre distance (PZ), and locking-point positions to find a compatible replacement. Sending a photo of the lock's edge plate (the metal strip on the door edge) helps us identify it before we arrive.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            <strong>Signs it's time for attention:</strong> You need to lift the handle hard to lock, the key is getting stiff, or the door catches on the frame. Acting early can mean an adjustment rather than a broken mechanism—and avoids being locked out or unable to secure the door.
          </p>
        </>
      }
      commonProblems={[
        {
          title: "Door won't lock from outside",
          description: "Usually a problem with the multipoint mechanism or cylinder. We diagnose whether repair or replacement is needed."
        },
        {
          title: "Window stuck in one position",
          description: "Mechanism failure in the window hardware. We repair or replace the specific components at fault."
        },
        {
          title: "Draughty doors despite being closed",
          description: "Weather seals wear over time. Replacement seals and adjustment resolve most draught issues."
        },
        {
          title: "Handles loose or broken",
          description: "Simple but important repair. We match hardware styles and ensure secure fixing."
        },
        {
          title: "Double glazing misted up",
          description: "The sealed unit has failed. We replace the glass within your existing frame."
        },
        {
          title: "Door dropping and dragging",
          description: "Hinge wear or door settling. Adjustment or hinge replacement restores proper operation."
        }
      ]}
      whyChooseUs={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            We're a practical, no-nonsense service—exactly what's needed in Dagenham. We don't try to sell you things you don't need. If your door can be fixed with an adjustment or a single replacement part, that's what we'll recommend. We're building a business on reputation and repeat customers, not one-off overselling.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our local knowledge means we understand the typical issues that affect properties here. We've seen the common problems with certain types of installations and know the effective solutions. This experience helps us diagnose quickly and repair efficiently.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            For landlords and agents, we offer reliability and fair pricing. We turn up when we say we will, do the work properly, and invoice accurately. Many property professionals in the area use us regularly because we make their lives easier rather than harder.
          </p>
        </>
      }
      ctaText="Need a Door, Window or Lock Specialist in Dagenham?"
    />
  );
};
